import { gql } from "@apollo/client";

export const ACCEPT_INVITATION = gql`
  mutation AcceptInvitation($invitationMrn: ID!) {
    acceptInvitation(invitationMrn: $invitationMrn)
  }
`;
